import React from 'react'
import { Modal } from 'react-bootstrap'
import { trackGTMEvents, i18nTranslate } from 'src/utils'
import { LinkWithLocale, ImageComponent } from 'src/views/components'
import { ProductDetails } from '../ProductDetails'
import { constructDateV2, currentMonthV2, currentYearV2 } from 'src/deps'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import { subscriptionContainer } from 'src/models'
import './styles.scss'

class SkipItemModal extends React.Component {
  trackGTMEventForSubscriptionSkipNo = () => {
    const { itemDetails, isSkipped } = this.props
    trackGTMEvents({
      event: 'subscriptionSkipNo',
      name: itemDetails?.productName || '',
      id: itemDetails?.subscriptionId || '',
      price: itemDetails?.subTotal || 0,
      type: 'next orders',
      message: !isSkipped ? subscriptionContainer.skipDeleteLoyaltyMFEMsg : '',
    })
  }

  render() {
    const { itemDetails, isSkipped, data } = this.props
    const { frequencyPeriod } = data
    const tittle = isSkipped
      ? i18nTranslate(
          'subscription.itemUnSkipQuestion',
          'Do you want to un skip this item on your next order?'
        )
      : i18nTranslate(
          'subscription.itemSkipQuestion',
          'Do you want to skip this item on your next order?'
        )
    const continueBtnText = isSkipped
      ? i18nTranslate(
          'subscription.itemUnSkipConfirm',
          'Yes, Un skip this item'
        )
      : i18nTranslate('subscription.itemSkipConfirm', 'Yes, skip this item')
    const backBtnText = isSkipped
      ? i18nTranslate('subscription.itemUnSkipBack', 'No, don’t Un skip')
      : i18nTranslate('subscription.itemSkipBack', 'No, don’t skip')
    let selectedMonth = data?.selectedMonth || new Date().getMonth()
    const selectedDate = data?.selectedDate || new Date().getDate()
    let currentMonth = currentMonthV2() || 0
    const currentYear = currentYearV2()
    const isNextYearMonth = currentMonth > selectedMonth - 1
    const year = isNextYearMonth ? parseInt(currentYear) + 1 : currentYear
    const currentProcessDate = constructDateV2(
      year,
      selectedMonth - 1,
      selectedDate
    )
    let skipToDate = currentProcessDate
    skipToDate.setMonth(skipToDate.getMonth() + frequencyPeriod)
    const option = {
      // timeZone: 'UTC',
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }
    const displayDate = skipToDate.toLocaleString('default', option)
    const subscriptionItemTotal =
      itemDetails?.priceObj?.price * itemDetails?.quantity
    const showLoyaltyAlert = selectedMonth === currentMonth + 1
    return (
      <Modal
        {...this.props}
        size="lg"
        className="skip-modal-container"
        centered>
        <Modal.Header closeButton>
          <Modal.Title
            className="skip-modal-question"
            data-testid="qa-sub-skip-tittle">
            {tittle}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showLoyaltyAlert && (
            <LoyaltyMFEContainer
              componentName="App"
              isFrom="SKIP"
              itemValue={subscriptionItemTotal}
            />
          )}
          <div className="skip-modal-description d-flex">
            <div className="product-list-product-img">
              <LinkWithLocale
                to={{
                  pathname: itemDetails.url || '',
                }}
                className={`prod-image-wrapper w-100`}
                data-testid="qa-sub-skip-image">
                <ImageComponent
                  width="100px"
                  height="100px"
                  optimizeImage={true}
                  src={itemDetails.productImage}
                  alt={itemDetails.productName}
                  className={`mw-100 mh-100 prod-img`}
                  data-testid="qa-user-sub-product-image"
                />
              </LinkWithLocale>
            </div>
            <ProductDetails productData={itemDetails} isFromDelete={true} />
          </div>
          {!isSkipped && (
            <div className="skipped-date-section">
              <span data-testid="qa-sub-skipping-date-label">
                {i18nTranslate(
                  'subscription.skipToDate',
                  'If skipped, next processing date will be'
                )}
              </span>
              <div className="skipped-date" data-testid="qa-sub-skipping-date">
                {displayDate}
              </div>
            </div>
          )}
          <div className="skip-modal-button-container">
            <button
              className="skip-modal-button-continue"
              data-testid="qa-sub-skip-button-continue"
              onClick={() =>
                this.props.handlerSkipItem(
                  itemDetails.subscriptionId,
                  !isSkipped,
                  itemDetails,
                  selectedMonth
                )
              }>
              {continueBtnText}
            </button>
            <button
              className="skip-modal-button-back"
              data-testid="qa-sub-skip-back-button"
              onClick={() => {
                this.trackGTMEventForSubscriptionSkipNo()
                this.props.onHide()
              }}>
              {backBtnText}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
export default SkipItemModal
export { SkipItemModal }
